


























































































import { Component, Mixins } from "vue-property-decorator";
import { thumbsUp } from "@/http/case";
import { sendSms, mobileLogin, getCaseDetailMobile, thumbsUpNum } from "@/http/case";
import "@/utils/util";
import "pdfh5/css/pdfh5.css";
import { DetailMixins } from "./detailMixins";
import Pdfh5 from "pdfh5";
@Component
export default class H5Detail extends Mixins(DetailMixins) {
  public visible = false;
  public pdfurl: string | null = null;
  public totalPage = 0;
  public loginSuccess = false;
  public thumbsOver = false;
  public pdfh5 = null;
  public pdfLoaded = false;
  qrCodeIsSend = false;
  time = 300;
  public form = {
    mobile: "",
    verCode: ""
  };
  public rules = {
    mobile: [
      { required: true, message: "请填写手机号" },
      {
        pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
        message: "请填写正确的手机号"
      }
    ],
    verCode: [{ required: true, min: 6, max: 6, message: "请填写正确的验证码" }]
  };
  //登录
  onSubmit() {
    (this.$refs["login"] as any).validate((valid: boolean, res: object) => {
      if (valid) {
        mobileLogin(this.form)
          .then(res => {
            const result = this.validateResponse(res) as any;
            if (result && result.success) {
              this.visible = false;
              this.loginSuccess = true;
              this.pdfLoaded = false;
              this.getInfo();
              this.checkThumbsUp();
            }
          })
          .catch(e => {
            this.showMessage("warning", "网络错误");
          });
      } else {
        this.showMessage("warning", "请填写正确的信息");
      }
    });
  }
  get qrName() {
    return this.qrCodeIsSend ? `已发送(${this.time}s)` : "发送验证码";
  }
  async handleQrCodeClick() {
    const ref = this.$refs.login as any;
    await ref.validateField("mobile", async (message: any) => {
      if (!message) {
        const { mobile } = this.form;
        await sendSms(mobile);
        this.qrCodeIsSend = true;
        const timer = setInterval(() => {
          this.time -= 1;
          if (this.time === 0) {
            this.qrCodeIsSend = false;
            this.time = 60;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.showMessage("warning", "请填写正确的手机号");
      }
    });
  }
  checkThumbsUp(){
    thumbsUpNum().then(res => {
      const result = this.validateResponse(res) as any;
      if (result && result.success) {
        this.thumbsOver = result.data > 2
      }
    })
  }
  // 投票
  handleVote() {
    thumbsUp(this.id)
      .then(res => {
        const result = this.validateResponse(res) as any;
        if (result && result.success && result.data.success) {
          this.showMessage("success", "投票成功");
          if (this.dataInfo) {
            this.dataInfo.thumbsUpStatus = true;
            this.getInfo()
          }
        }
        if (!result.data.success){
          this.showMessage("warning", result.data.message)
        }
      })
      .catch(e => {
        this.showMessage("warning", "网络错误");
      });
  }
  getInfo() {
    getCaseDetailMobile(this.id)
      .then(res => {
        const result = this.validateResponse(res) as any;
        if (result && result.success) {
          this.dataInfo = result.data;
          document.title = `${result.data.caseName}-${result.data.hospitalName}`;
          if (this.loginSuccess && !this.pdfLoaded) {
            this.loadPdf();
          }
          if (!this.loginSuccess) {
            this.visible = true;
          }
        }
      })
      .catch(e => {
        this.showMessage("warning", "网络错误");
      });
  }
  async loadPdf() {
    if (this.dataInfo) {
      this.pdfh5 = new Pdfh5('#demo', {
        pdfurl: `${this.baseUrl}/api/mr/pdf?url=${this.dataInfo.pdfUrl}`
      });
      (this.pdfh5 as any).on("complete", () => {
        (this.pdfh5 as any).scrollEnable(true);
        this.pdfLoaded = true;
      });
    }
  }
  validateResponse(res: any) {
    const { status, data } = res;
    if (status === 200) {
      if (data.status === 0) {
        return {
          success: true,
          data: data.result
        };
      } else {
        this.showMessage("warning", data.message);
      }
    } else {
      this.showMessage("warning", "系统错误");
    }
  }
  showMessage(type: string, message: string) {
    const className =
      type === "success" ? "mobile-message-success" : "mobile-message-warning";
    const iconClass =
      type === "success" ? "el-icon-success" : "el-icon-warning";
    this.$message({
      iconClass: iconClass,
      customClass: className,
      dangerouslyUseHTMLString: true,
      message: message
    });
  }
  mounted() {
    const appDom = document.getElementById("app");
    if (appDom) {
      appDom.style.minWidth = "100px";
    }
    this.getInfo();
  }
}
